<template>
  <div class="patient-courses-filters">
    <dialog-select
      name="coursesStatus"
      :items="coursesFilters"
      :value="status"
      placeholder="Status"
      customClass="filter"
      itemText="label"
      itemValue="value"
      @input="filterCourses"
    />
  </div>
</template>

<script>
import DialogSelect from '@/components/forms/DialogSelect'

export default {
  name: 'PatientCoursesFilters',
  components: {
    DialogSelect,
  },
  props: ['status'],
  data() {
    return {
      coursesFilters: [
        { label: 'Enrolled', value: 'ACTIVE' },
        { label: 'Available', value: 'LIBRARY' },
      ],
    }
  },
  methods: {
    filterCourses(status) {
      const statusValue = status.value
      this.$emit('filter-courses', statusValue)
    },
  },
}
</script>
<style lang="scss">
.patient-courses-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  .dialog-select {
    width: 200px;
  }
}
</style>
